import { render, staticRenderFns } from "./TabCguv.vue?vue&type=template&id=7f2107b7&scoped=true"
import script from "./TabCguv.vue?vue&type=script&lang=js"
export * from "./TabCguv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2107b7",
  null
  
)

export default component.exports